export interface GiftCard {
	id: string
	code: string
	balance: number
	currency: string
	initialBalance: number
	expirationDate: any
	purchasedBy: string // User ID
	recipient: {
		name: string
		email: string
		phoneNumber: string
		giftNote: string
	} | null
	createdAt: Date
	notifications: [
		{
			method: string // 'sms' | 'email'
			timeSent: Date
			status: string // 'pending' | 'sent'
		},
	]

	// Collections
	GiftCardTransactions: [
		{
			orderId: string
			amount: number
			date: Date
			type: string // 'purchase' | 'reload'
		},
	]
}

/**
 * Checks if gift card is valid for use.
 *
 * @param giftCard GiftCard document object.
 * @returns a boolean, true or false based on validity.
 */
export const isGiftCardValid = (giftCard: GiftCard) => {
	return giftCard.balance > 0
}
